import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DomSanitizer, SafeHtml, SafeResourceUrl} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {AppHttpParams} from '../../shared/models/app-http-params';
import {AppConfigService} from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class HtmlTemplatesService {

  constructor(private translateService: TranslateService,
              private sanitizer: DomSanitizer,
              private httpClient: HttpClient) {
  }


  getGdprTemplate(): Observable<SafeHtml> {
    return this.getPrivacyPolicy();
  }

  getPrivacyPolicy(): Observable<SafeHtml> {
    return this.getTemplate('/assets/static/privacy_policy_' + AppConfigService.settings.localization.localizationCountry + '_' + this.translateService.currentLang + '.html');
  }

  getMobileDataPrivacyPolicy(lang: string): Observable<SafeHtml> {
    return this.getTemplate('/assets/static/mobile_app_data_privacy_policy_' + lang + '.html');
  }

  getTermsAndConditions(): Observable<SafeHtml> {
    return this.getTemplate('/assets/static/terms_and_conditions_' + AppConfigService.settings.localization.localizationCountry + '_' + this.translateService.currentLang + '.html');
  }

  getTermsOfUse(): Observable<SafeHtml> {
    return this.getTemplate('/assets/static/terms_of_use_' + AppConfigService.settings.localization.localizationCountry + '_' + this.translateService.currentLang + '.html');
  }

  getHomePage(): Observable<SafeHtml> {
    return this.getTemplate('/assets/static/home_page_' + AppConfigService.settings.localization.localizationCountry + '_' + this.translateService.currentLang + '.html');
  }

  getFaq(type: string): Observable<SafeHtml> {
    return this.getTemplate('/assets/static/faq_' + type + '_' + AppConfigService.settings.localization.localizationCountry + '_'  + this.translateService.currentLang + '.html');
  }

  getUserGuideUrl(): Observable<string> {
    const translatedGuideUrl = '/assets/static/User_Guide_' + this.translateService.currentLang + '.pdf';
    return this.testPdf(translatedGuideUrl).pipe(map(() => {
      return translatedGuideUrl;
    }), catchError(() => {
      return of('/assets/static/User_Guide.pdf');
    }));
  }

    getPolicyUrl(): Observable<string> {
    const translatedGuideUrl = '/assets/static/TX Manager_Privacy_Policy' + this.translateService.currentLang + '.pdf';
    return this.testPdf(translatedGuideUrl).pipe(map(() => {
      return translatedGuideUrl;
    }), catchError(() => {
      return of('/assets/static/TX Manager_Privacy_Policy.pdf');
    }));
  }

  getTermUrl(){
     const translatedGuideUrl = '/assets/static/TX_Manager_Terms' + this.translateService.currentLang + '.pdf';
    return this.testPdf(translatedGuideUrl).pipe(map(() => {
      return translatedGuideUrl;
    }), catchError(() => {
      return of('/assets/static/TX_Manager_Terms.pdf');
    }));
  }

  private getTemplate(url: string): Observable<SafeHtml> {
    const currentLang = this.translateService.currentLang;
    const isEn = !currentLang || currentLang === 'en' || url.endsWith('_en.html');
    
    const notifyError = isEn;
    const appParams = new AppHttpParams({notifyError});

    return this.httpClient.get(url, {responseType: 'text', params: appParams}).pipe(
      map(response => this.sanitizer.bypassSecurityTrustHtml(response)),
      catchError(() => {
        if (!isEn) {
          const fallbackUrl = url.replace(`_${currentLang}.html`, '_en.html');
          if (fallbackUrl !== url) {
            const fallbackParams = new AppHttpParams({notifyError: true});
            return this.httpClient.get(fallbackUrl, {responseType: 'text', params: fallbackParams}).pipe(
              map(response => this.sanitizer.bypassSecurityTrustHtml(response)),
              catchError(() => of(''))
            );
          }
        }
        return of('');
      })
    );
  }

  testPdf(url: string): Observable<any> {
    return this.httpClient.get(url, {responseType: 'text'});
  }

}
